<template>
  <div
    v-show="$route.name === 'Collection' || $route.name === 'Notes' || $route.name.includes('List')"
    class="item-list-top-bar">
    <div class="item-list-top-bar-batch">
      <i
        class="mdi mdi-checkbox-blank-outline select-all-icon"
        :class="{
          'select-all-icon-active': batchSelectActive,
          'mdi-checkbox-marked': allItemsAreSelected,
        }"
        @click="$emit('toggle-select-all')" />
      <i
        v-show="batchSelectActive"
        class="mdi mdi-dots-horizontal batch-menu-icon"
        @click.stop="toggleShowBatchMenu" />
      <transition name="fade">
        <div
          v-if="showBatchMenu"
          class="collection-list-item-menu batch-menu"
          @click="$emit('hide-menu')"
          ref="contextMenu">
          <div
            class="collection-list-item-menu-item collection-list-item-menu-header">
            <b>{{ selectedLength }} item(s) selected</b>
          </div>
          <div class="collection-list-item-menu-divider" />
          <div
            class="collection-list-item-menu-item"
            @click="moveSelected">
            Move
          </div>
          <div
            class="collection-list-item-menu-item"
            @mouseenter="contextMenuShowSections = true"
            @mouseleave="contextMenuShowSections = false">
            Section<i class="mdi mdi-chevron-right" style="float: right" />
            <transition name="fade">
              <div
                v-if="contextMenuShowSections"
                @mouseleave="contextMenuShowSections = false"
                class="collection-list-item-menu-sub"
                style="left: 10rem">
                <div
                  class="collection-list-item-menu-item"
                  @click="updateSection(null)">
                  <em>None</em>
                </div>
                <div
                  v-for="section in sections"
                  :key="section"
                  class="collection-list-item-menu-item"
                  @click="updateSection(section)">
                  {{ section }}
                </div>
                <div
                  class="collection-list-item-menu-item"
                  @click.stop>
                  <input
                    class="new-section-input"
                    type="text"
                    placeholder="Add section"
                    v-model="newSection"
                    @keyup.enter="addSection" />
                </div>
              </div>
            </transition>
          </div>
          <div class="collection-list-item-menu-divider" />
          <div
            class="collection-list-item-menu-item"
            style="color: red"
            @click="deleteSelected">
            Delete
          </div>
        </div>
      </transition>
    </div>
    <div
      class="item-list-top-bar-title"
      @click="sortSetting === 'alphabetical-asc'
        ? setSortSetting('alphabetical-desc')
        : setSortSetting('alphabetical-asc')">
      Title
      <i
        v-show="sortSetting === 'alphabetical-desc'"
        class="mdi mdi-menu-down" />
      <i
        v-show="sortSetting === 'alphabetical-asc'"
        class="mdi mdi-menu-up" />
    </div>
    <div
      class="item-list-top-bar-stars"
      @click="sortSetting === 'stars-asc'
        ? setSortSetting('stars-desc')
        : setSortSetting('stars-asc')">
      Stars
      <i
        v-show="sortSetting === 'stars-desc'"
        class="mdi mdi-menu-down" />
      <i
        v-show="sortSetting === 'stars-asc'"
        class="mdi mdi-menu-up" />
    </div>
    <div
      class="item-list-top-bar-date"
      @click="sortSetting === 'modified-asc'
        ? setSortSetting('modified-desc')
        : setSortSetting('modified-asc')">
      Last modified
      <i
        v-show="sortSetting === 'modified-desc'"
        class="mdi mdi-menu-down" />
      <i
        v-show="sortSetting === 'modified-asc'"
        class="mdi mdi-menu-up" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
// eslint-disable-next-line import/extensions
import { EventBus } from '@/EventBus.js';

export default {
  name: 'ListTopBar',
  props: {
    batchSelectActive: {
      type: Boolean,
      required: true,
      default: false,
    },
    allItemsAreSelected: {
      type: Boolean,
      required: true,
      default: false,
    },
    sections: {
      type: Array,
      required: false,
      default: () => [],
    },
    rowMenuActive: Boolean,
    selectedLength: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showBatchMenu: false,
      contextMenuShowSections: false,
      newSection: null,
    };
  },
  computed: {
    ...mapState({
      sortSetting: state => state.appState.localSettings.collectionViewSortSetting,
    }),
  },
  methods: {
    ...mapMutations({
      setSortSetting: 'appState/SetCollectionViewSortSetting',
    }),
    toggleShowBatchMenu(e) {
      this.$emit('hide-row-menu');
      this.showBatchMenu = !this.showBatchMenu;
    },
    addSection(event) {
      if (!this.newSection) return;

      this.$emit('update-section', this.newSection);
      this.newSection = null;
      this.contextMenuShowSections = false;
      this.showBatchMenu = false;
    },
    updateSection(section) {
      this.$emit('update-section', section);
      this.contextMenuShowSections = false;
      this.showBatchMenu = false;
    },
    moveSelected() {
      this.showBatchMenu = false;
      this.$emit('moveSelected');
    },
    deleteSelected() {
      this.showBatchMenu = false;
      this.$emit('deleteSelected');
    },
    checkHideContextMenu(e) {
      // Outside menu clicks are handled here
      if (this.showBatchMenu && !e.target.className.includes('batch-menu-icon')) {
        e.stopPropagation();
        this.showBatchMenu = false;
      }
    },
  },
  watch: {
    batchSelectActive() {
      if (!this.batchSelectActive) this.showBatchMenu = false;
    },
    rowMenuActive() {
      if (this.rowMenuActive) this.showBatchMenu = false;
    },
  },
  mounted() {
    EventBus.$on('check-hide-context-menu', this.checkHideContextMenu);
  },
  beforeDestroy() {
    EventBus.$off('check-hide-context-menu', this.checkHideContextMenu);
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';

.item-list-top-bar {
  position: relative;
  width: 100%;
  height: calc(1.5rem + 1px); // +1px to get total height of collection-navigation-tabs, collection-item-tabs, and list-top-bar to 6.5rem
  font-size: 0.7rem;
  color: rgba($black, 0.75);
  display: flex;
  align-items: center;
  padding: 0 1rem 0 0.75rem;
  border-bottom: 1px solid #efefef;
  user-select: none;
}
.item-list-top-bar > div {
  padding: 0.25rem;
}
.item-list-top-bar-batch {
  position: relative;
  width: 4rem;
  font-size: 1rem;
  padding: 0 !important;
  white-space: nowrap;
}
.item-list-top-bar-batch > i {
  margin-right: 0.5rem;
  cursor: pointer;
}
.item-list-top-bar-batch:hover .select-all-icon {
  opacity: 0.5;
}
.select-all-icon {
  opacity: 0;
  font-size: 1.15rem;
}
.select-all-icon-active {
  opacity: 1 !important;
}
.batch-menu-icon {
  font-size: 1.15rem;
}
// .batch-menu {
//   position: absolute;
//   left: 1.5rem;
//   top: 1.25rem;
//   width: 4rem;
//   background-color: $primary;
//   border-radius: 0 0.25rem 0.25rem 0.25rem;
//   overflow: hidden;
//   font-size: 0.8rem;
//   z-index: 60;
//   opacity: 1;
//   padding: 0 !important;
//   white-space: normal;
// }
.batch-menu {
  left: 3rem;
}
.batch-menu-item {
  cursor: pointer;
  user-select: none;
  width: 100%;
  padding: 0.25rem 0.5rem !important;
}
.batch-menu-item:hover {
  background-color: rgba($primary-dark, 0.4);
}
.item-list-top-bar-title {
  width: calc(100% - 17rem); // 19.25rem is all stuff around the title column
  width: 100%;
  cursor: pointer;
}
.item-list-top-bar-title,
.item-list-top-bar-stars,
.item-list-top-bar-date {
  height: calc(1.5rem + 1px);
  white-space: nowrap;
  overflow: hidden;
}
.item-list-top-bar-title:hover,
.item-list-top-bar-stars:hover,
.item-list-top-bar-date:hover {
  background-color: rgba($primary, 0.35);
}
.item-list-top-bar-title:active,
.item-list-top-bar-stars:active,
.item-list-top-bar-date:active {
  background-color: rgba($primary, 0.5);
}
.item-list-top-bar-stars {
  width: 4.5rem;
  flex: 0 0 auto;
  text-align: center;
  cursor: pointer;
}
.item-list-top-bar-date {
  width: 7rem;
  flex: 0 0 auto;
  cursor: pointer;
}

.fade-leave-active {
  transition: opacity 0.15s 0.1s;
}
.fade-enter-active {
  transition: opacity 0.15s 0s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
